import { base } from './base';

export const kalmar = Object.assign({}, base, {});
